export const isPromise = (
    result: void | Promise<void>
): result is Promise<void> => {
    return typeof result === 'object' && typeof result.then === 'function'
}
